import { forwardRef, Inject, Pipe, PipeTransform } from '@angular/core';
import { PartnerStatus } from '../../model';
import { StatusTagPipe } from './status-tag.pipe';
import { UnderscoreRemoverPipe } from './underscore-remover.pipe';

@Pipe({ name: 'partnerStatus' })
export class PartnerStatusPipe implements PipeTransform {

    constructor(
        @Inject(forwardRef(() => StatusTagPipe)) private statusTagPipe: StatusTagPipe,
        @Inject(forwardRef(() => UnderscoreRemoverPipe)) private underscoreRemoverPipe: UnderscoreRemoverPipe
    ) {
    }

    transform(value: PartnerStatus): string {
        switch (value) {
            case PartnerStatus.ACTIVE:
                return this.statusTagPipe.transform(this.underscoreRemoverPipe.transform(value), { icon: null, iconStyle: null, color: '#3D7300', backgroundColor: '#7AE50026' });
            case PartnerStatus.PENDING_APPROVAL:
                return this.statusTagPipe.transform(this.underscoreRemoverPipe.transform(value), { icon: null, iconStyle: null, color: '#7B3E00', backgroundColor: '#F57B0026' });
            case PartnerStatus.SUSPENDED:
                return this.statusTagPipe.transform(this.underscoreRemoverPipe.transform(value), { icon: null, iconStyle: null, color: '#7C0505', backgroundColor: '#F80A0A26' });
            default: return '';
        }
    }
}

